module.exports = __webpack_public_path__ + "static/media/Takehiro.772329b9.png";